import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  Label,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import { callApi } from '../../utils';
import { showError } from '../../actions/notificationActions';

import SearchForm from '../SearchForm';
import Table from './Table';
import DetailModal from './Modal';

class ManualTopups extends Component {
  state = {
    records: [],
    loading: false,
    limit: 20,
    meta: { nextCursor: null },

    // Filters
    search: '',
    status: '', // ALL by default
    source_type: '', // ALL by default
    fromDate: '',
    toDate: '',

    // Pagination
    cursors: [null], // index 0 is first page (no cursor)
    currentIndex: 0,

    // Dropdown UI state
    statusOpen: false,
    sourceOpen: false,

    // Modal state
    modalOpen: false,
    selectedRecordId: null,
  };

  componentDidMount() {
    this.loadRecords();
  }

  loadRecords = () => {
    this.setState({ loading: true });
    const {
      search,
      status,
      source_type,
      fromDate,
      toDate,
      limit,
      cursors,
      currentIndex,
    } = this.state;

    const cursor = cursors[currentIndex];

    const params = {
      limit,
    };

    if (cursor) params.cursor = cursor;
    if (status) params.status = status;
    if (source_type) params.source_type = source_type;
    if (search) params.search = search;
    if (fromDate) params.fromdate = fromDate;
    if (toDate) params.todate = toDate;

    callApi('/manual-topups', params)
      .then(({ data = [], meta }) => {
        this.setState({
          loading: false,
          records: data,
          meta: meta || { nextCursor: null },
        });
      })
      .catch((err) => {
        this.setState({ loading: false });
        this.props.dispatch(showError(err));
      });
  };

  resetPaginationAndReload = () => {
    this.setState(
      {
        cursors: [null],
        currentIndex: 0,
      },
      () => {
        this.loadRecords();
      }
    );
  };

  handleSearch = (e) => {
    if (e) e.preventDefault();
    this.resetPaginationAndReload();
  };

  handleFilterChange = (field, value) => {
    this.setState({ [field]: value }, () => {
      this.resetPaginationAndReload();
    });
  };

  handleClearFilters = () => {
    this.setState(
      {
        search: '',
        status: '',
        source_type: '',
        fromDate: '',
        toDate: '',
      },
      () => {
        this.resetPaginationAndReload();
      }
    );
  };

  handleNextPage = () => {
    const { meta, cursors, currentIndex } = this.state;
    if (!meta.nextCursor) return;

    const nextIndex = currentIndex + 1;
    const newCursors = [...cursors];
    newCursors[nextIndex] = meta.nextCursor;

    this.setState(
      {
        cursors: newCursors,
        currentIndex: nextIndex,
      },
      () => {
        this.loadRecords();
      }
    );
  };

  handlePrevPage = () => {
    const { currentIndex } = this.state;
    if (currentIndex === 0) return;

    this.setState(
      {
        currentIndex: currentIndex - 1,
      },
      () => {
        this.loadRecords();
      }
    );
  };

  handleSelectRecord = (id) => {
    this.setState({
      selectedRecordId: id,
      modalOpen: true,
    });
  };

  toggleModal = () => {
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen,
    }));
  };

  render() {
    const {
      records,
      loading,
      search,
      status,
      source_type,
      fromDate,
      toDate,
      currentIndex,
      meta,
      modalOpen,
      selectedRecordId,
      statusOpen,
      sourceOpen,
    } = this.state;

    return (
      <div className="content">
        <DetailModal
          isOpen={modalOpen}
          recordId={selectedRecordId}
          toggle={this.toggleModal}
          onSuccess={this.loadRecords}
        />

        <Row>
          <Col xs={12}>
            <Card>
              <CardHeader className="ml-2">
                <CardTitle>Manual Topups</CardTitle>
                <p className="category">Manage manual user wallet topups.</p>
              </CardHeader>
              <CardBody style={{ padding: 0 }}>
                {/* Search & Filters */}
                <div className="p-3 mb-0">
                  <Row className="align-items-end">
                    <Col lg={4} md={6} sm={12} className="mb-3">
                      <Label className="font-weight-bold">Search Text</Label>
                      <SearchForm
                        value={search}
                        placeholder="Search ref, bank, session id..."
                        onChange={(e) =>
                          this.setState({ search: e.target.value })
                        }
                        onSearch={this.handleSearch}
                        loading={loading}
                      />
                    </Col>
                    <Col lg={2} md={3} sm={6} className="mb-3">
                      <Label className="font-weight-bold d-block">Status</Label>
                      <Dropdown
                        isOpen={statusOpen}
                        toggle={() =>
                          this.setState({ statusOpen: !statusOpen })
                        }
                      >
                        <DropdownToggle
                          caret
                          color="secondary"
                          className="m-0 w-100 text-left d-flex justify-content-between align-items-center"
                        >
                          {status || 'ALL'}
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem
                            onClick={() =>
                              this.handleFilterChange('status', '')
                            }
                          >
                            ALL
                          </DropdownItem>
                          <DropdownItem
                            onClick={() =>
                              this.handleFilterChange('status', 'PENDING')
                            }
                          >
                            PENDING
                          </DropdownItem>
                          <DropdownItem
                            onClick={() =>
                              this.handleFilterChange('status', 'APPROVED')
                            }
                          >
                            APPROVED
                          </DropdownItem>
                          <DropdownItem
                            onClick={() =>
                              this.handleFilterChange('status', 'REJECTED')
                            }
                          >
                            REJECTED
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </Col>
                    <Col lg={2} md={3} sm={6} className="mb-3">
                      <Label className="font-weight-bold d-block">
                        Source Type
                      </Label>
                      <Dropdown
                        isOpen={sourceOpen}
                        toggle={() =>
                          this.setState({ sourceOpen: !sourceOpen })
                        }
                      >
                        <DropdownToggle
                          caret
                          color="secondary"
                          className="m-0 w-100 text-left d-flex justify-content-between align-items-center"
                        >
                          {source_type || 'ALL'}
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem
                            onClick={() =>
                              this.handleFilterChange('source_type', '')
                            }
                          >
                            ALL
                          </DropdownItem>
                          <DropdownItem
                            onClick={() =>
                              this.handleFilterChange('source_type', 'EMAIL')
                            }
                          >
                            EMAIL
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </Col>
                    <Col lg={2} md={4} sm={6} className="mb-3">
                      <Label className="font-weight-bold">From Date</Label>
                      <Input
                        type="date"
                        value={fromDate}
                        onChange={(e) =>
                          this.handleFilterChange('fromDate', e.target.value)
                        }
                        className="m-0"
                      />
                    </Col>
                    <Col lg={2} md={4} sm={6} className="mb-3">
                      <Label className="font-weight-bold">To Date</Label>
                      <Input
                        type="date"
                        value={toDate}
                        onChange={(e) =>
                          this.handleFilterChange('toDate', e.target.value)
                        }
                        className="m-0"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="text-right">
                      <Button
                        color="warning"
                        size="sm"
                        onClick={this.handleClearFilters}
                      >
                        Reset Filters
                      </Button>
                    </Col>
                  </Row>
                </div>

                <Table
                  records={records}
                  loading={loading}
                  onSelect={this.handleSelectRecord}
                  limit={this.state.limit}
                  footer={
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <span className="text-muted small">
                          Page {currentIndex + 1}
                        </span>
                      </div>
                      <div>
                        <Button
                          color="primary"
                          size="sm"
                          onClick={this.handlePrevPage}
                          disabled={currentIndex === 0}
                          className="mr-2"
                        >
                          &larr; Prev
                        </Button>
                        <Button
                          color="primary"
                          size="sm"
                          onClick={this.handleNextPage}
                          disabled={!meta.nextCursor}
                        >
                          Next &rarr;
                        </Button>
                      </div>
                    </div>
                  }
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect()(ManualTopups);
